module.exports = __webpack_public_path__ + "static/media/sean.95261f05.png";